import {Component, Injector, OnInit} from '@angular/core';

@Component({
    selector: 'unidad-familia-barra',
    standalone: false,
    templateUrl: 'unidad-familia-barra.component.html'
})

export class UnidadFamiliaBarraComponent implements OnInit {

    unidad;

    constructor(private injector: Injector) { }

    ngOnInit() {
        this.unidad = this.injector.get('unidad');
    }
}